import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-left":"auto","margin-right":"auto","padding":"8px","width":"100%","display":"block"} }

import { onMounted, ref } from 'vue';
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import axios from 'axios';
import _ from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'GamesView',
  setup(__props) {

let search = ref('');
let gridApi: any = null;
let bots = ref([]);
let selectedChannel: any = ref(null);

let columns = ref([
    { field: 'code', headerName: 'Code' },
    { field: 'game', headerName: 'Game' },
    { field: 'streamer.twitch', headerName: 'Recorded By' },
]);

let rows = ref([]);

function onGridReady(params: any) {
    gridApi = params.api;
}

function onFilterTextBoxChanged(event: any) {

    gridApi.setGridOption(
        'quickFilterText',
        event?.target?.value
    );
}

function pickChannel($event: string) {

    let bot = _.find(bots.value, (b: any) => b?.name?.toLowerCase() === $event.toLowerCase());
    rows.value = bot.videos || [];
}

onMounted(async () => {
    console.log('loaded');
    let resp = await axios.get('/api/bot/channelInfo');
    bots.value = resp.data ?? [];
    rows.value = resp.data[0]?.videos ?? [];
    selectedChannel.value = resp?.data[0].name;
});


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_grid = _resolveComponent("v-grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_select, {
        "onUpdate:modelValue": [
          pickChannel,
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedChannel) ? (selectedChannel).value = $event : selectedChannel = $event))
        ],
        modelValue: _unref(selectedChannel),
        "item-value": "name",
        "item-title": "name",
        label: "Channel",
        items: _unref(bots),
        style: {"display":"inline-block","width":"250px"}
      }, null, 8, ["modelValue", "items"]),
      _createVNode(_component_v_text_field, {
        label: "Filter",
        modelValue: _unref(search),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(search) ? (search).value = $event : search = $event)),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (onFilterTextBoxChanged($event))),
        style: {"display":"inline-block","width":"250px","margin-left":"8px"}
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_grid, {
      onGridReady: onGridReady,
      class: "ag-theme-quartz-auto-dark",
      rowData: _unref(rows),
      columnDefs: _unref(columns),
      enableCellTextSelection: true,
      style: {"height":"calc(100% - 85px)"}
    }, null, 8, ["rowData", "columnDefs"])
  ]))
}
}

})